import { IonCard, IonCardContent } from "@ionic/react";
import React from 'react';
import ProgressiveImage from "./ProgressiveImage";
import DefaultImage from './imgs/loading.gif';

interface GridImagensProps { lista: any, history: any, excluirFoto: any }

export default class GridImagens extends React.Component<GridImagensProps> {

    render() {
        return this.props.lista.map((item: any) =>
            <div id='containerinterno'>
                <IonCard color='light'>
                    <div>
                        <div style={{ width: 'fit-content', height: 'fit-content' }} onClick={() => { { this.props.history.push("galeriafoco", { url: item.urlFile, titulo: item.descricao }) } }}>
                            {/*<img src={item.urlFile} onClick={() => { { this.props.history.push("galeriafoco", { url: item.urlFile, titulo: item.descricao }) } }}></img>*/}
                            <ProgressiveImage imgSrc={item.urlFile} previewSrc={DefaultImage} width={'auto'} height={"auto"} />
                        </div>
                        <div className='fabCategoria' style={{ position: 'relative' }}>
                        </div>
                    </div>
                    <IonCardContent onClick={() => { this.props.history.push("galeriafoco", { url: item.urlFile, titulo: item.descricao }); }}><h3>{item.descricao}</h3></IonCardContent>
                </IonCard>
            </div>)
    }

}
